import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

import { paths } from 'src/routes/routes/paths';

// eslint-disable-next-line import/no-cycle
import { useSetRole, useSetToken } from 'src/hooks/useHandleSessions';

import { activeSnack } from './common';
import { get, put, post, contactPost } from '../http';

export const forgotPassword = createAsyncThunk(
  'auth/forgot',
  async ({ state, enqueueSnackbar, handleRoles }) => {
    try {
      const response = await post(`/forgot`, state);
      if (response) {
        enqueueSnackbar('Email Sent Successfully!');
        if (handleRoles) {
          localStorage.setItem('userRole', handleRoles());
        }
        useSetToken(response?.token);
        return response;
      }
      return enqueueSnackbar('something went wrong', { variant: 'error' });
    } catch (error) {
      enqueueSnackbar(error?.response?.data?.message, { variant: 'error' });
      throw error?.response?.data?.message;
    }
  }
);
export const updatePassword = createAsyncThunk(
  'auth/password/update',
  async ({ state, enqueueSnackbar, token, navigate, userType }) => {
    try {
      const response = await post(`password/reset/${token}`, state);

      if (response) {
        enqueueSnackbar('Password Updated Successfully!');
        useSetToken(response?.token);
        if (userType === 'member') {
          navigate(paths.auth.login_member);
        } else {
          navigate(paths.auth.login);
        }
        // navigate(paths?.auth?.login);

        return response;
      }
      return enqueueSnackbar('something went wrong', { variant: 'error' });
    } catch (error) {
      enqueueSnackbar(error?.response?.data?.message, { variant: 'error' });
      throw error?.response?.data?.message;
    }
  }
);

export const LoginApi = createAsyncThunk('auth/login', async ({ state, dispatch, navigate }) => {
  try {
    const response = await post('user/login', state);

    if (response) {
      dispatch(activeSnack({ type: 'success', message: 'Successfully Authenticated' }));
      useSetToken(response?.token);
      useSetRole(response?.role);
      navigate(paths?.dashboard?.root);
      return response;
    }

    navigate(paths?.auth?.login_otp_member, { replace: true });
    dispatch(
      activeSnack({
        type: 'success',
        message: 'An OTP has been successfully sent to your registered email.',
      })
    );
    return response;
  } catch (error) {
    console.log('error=>', error);
    dispatch(activeSnack({ type: 'error', message: error?.response?.data?.message }));
    throw error?.response?.data?.message;
  }
});

export const logoutApi = createAsyncThunk('auth/logout', async ({ dispatch, navigate }) => {
  try {
    const response = await get('/logout');
    if (response) {
      sessionStorage.clear();
      dispatch(activeSnack({ type: 'success', message: 'logged out successfully' }));
      navigate(paths.public.landing, { replace: true });
      return response;
    }
    return dispatch(activeSnack({ type: 'error', message: 'something went wrong' }));
  } catch (error) {
    sessionStorage.clear();
    navigate(paths.public.landing, { replace: true });
    dispatch(activeSnack({ type: 'error', message: error?.response?.data?.message }));
    throw error?.response?.data?.message;
  }
});

export const memberRegisterApi = createAsyncThunk(
  'auth/register',
  async ({ state, dispatch, navigate }) => {
    try {
      const response = await post('/user/register', state);

      if (response) {
        dispatch(activeSnack({ type: 'success', message: 'Successfully Registered' }));
        // navigate(paths?.auth?.login_otp_member);
        navigate(`${paths?.auth?.onBoarding}`);

        console.log(response);
        useSetToken(response?.token);
        useSetRole(response?.role);
        return response;
      }

      return dispatch(activeSnack({ type: 'error', message: 'something went wrong' }));
    } catch (error) {
      dispatch(activeSnack({ type: 'error', message: error?.response?.data?.message }));
      throw error?.response?.data?.message;
    }
  }
);
export const CheckUserName = createAsyncThunk('check/username', async ({ state }) => {
  try {
    const URL = `/check/username`;
    const response = await post(URL, state);
    if (response) {
      // dispatch(activeSnack({ type: 'success', message: response.message }));
      return response;
    }
    return false;
  } catch (error) {
    throw error?.response?.data?.message;
  }
});

export const verifyOtpApi = createAsyncThunk(
  'auth/otp',
  async ({ state, dispatch, handleNextStep, navigate, handleClose, enqueueSnackbar }) => {
    try {
      const response = await post('/verify/otp/', state);
      console.log(response);
      if (response) {
        useSetToken(response?.token);
        useSetRole(response?.role);
        if (enqueueSnackbar) {
          enqueueSnackbar(' OTP Verified Successfully!');
        }
        if (handleNextStep) {
          return handleNextStep();
        }

        if (handleClose) {
          handleClose();
        }
        if (navigate) {
          navigate(paths?.dashboard?.root, { replace: true });
        }

        // handleNextStep();
        return response;
      }
      // dispatch(activeSnack({ type: 'success', message: 'Successfully Authenticated ' }));

      return dispatch(activeSnack({ type: 'error', message: 'something went wrong' }));
    } catch (error) {
      dispatch(activeSnack({ type: 'error', message: error?.response?.data?.message }));
      throw error?.response?.data?.message;
    }
  }
);

export const getMemberProfile = createAsyncThunk(
  'user/profile/member',
  async ({ enqueueSnackbar, dispatch }) => {
    try {
      const response = await get(`/user/profile`);
      if (response?._id) {
        return response;
      }
      return enqueueSnackbar('something went wrong', { variant: 'error' });
    } catch (error) {
      console.log(error);
      enqueueSnackbar(error?.response?.data?.message, { variant: 'error' });
      throw error?.response?.data?.message;
    }
  }
);

export const getAdvertiserProfile = createAsyncThunk(
  'user/profile',
  async ({ enqueueSnackbar }) => {
    try {
      const response = await get(`/advertiser-account/advertiser/profile`);
      if (response?.advertiserAccountKey) {
        return response;
      }

      console.log(response);
      return enqueueSnackbar('something went wrong', { variant: 'error' });
    } catch (error) {
      console.log('error =>', error);
      enqueueSnackbar(error?.response?.data?.message, { variant: 'error' });
      throw error?.response?.data?.message;
    }
  }
);

export const updateMemberProfile = createAsyncThunk(
  'user/profile/update',
  async ({ enqueueSnackbar, navigate, state }) => {
    try {
      const response = await put(`/user/profile/update`, state);
      if (response?._id) {
        enqueueSnackbar(' Profile Updated Successfully', state);
        navigate(paths?.auth?.OnBoarding2);

        return response;
      }
      return enqueueSnackbar('something went wrong', { variant: 'error' });
    } catch (error) {
      console.log(error);
      enqueueSnackbar(error?.response?.data?.message, { variant: 'error' });
      throw error?.response?.data?.message;
    }
  }
);

// member login
export const memberLoginApi = createAsyncThunk(
  'auth/student/login',
  async ({ state, dispatch, navigate }) => {
    try {
      const response = await post('member/login', state);
      dispatch(activeSnack({ type: 'success', message: 'Successfully Authenticated ' }));
      if (response) {
        useSetToken(response?.token);
        useSetRole(response?.role);
        navigate(paths.dashboard?.root, { replace: true });
        return response;
      }

      return dispatch(activeSnack({ type: 'error', message: 'something went wrong' }));
    } catch (error) {
      dispatch(activeSnack({ type: 'error', message: error?.response?.data?.message }));
      throw error?.response?.data?.message;
    }
  }
);
export const ResentOtpApi = createAsyncThunk(
  'resend/otp',

  async ({ state, dispatch, handleNextStep, navigate }) => {
    try {
      const response = await post('/resend/otp', state);
      console.log(response);
      if (response) {
        // dispatch(
        //   activeSnack({
        //     type: 'success',
        //     message: '"An OTP has been successfully sent to your registered email.. ',
        //   })
        // );
        if (dispatch) {
          dispatch(
            activeSnack({
              type: 'success',
              message: '"An OTP has been successfully sent to your registered email.. ',
            })
          );
        }
        if (navigate) {
          navigate();
        }
        // handleNextStep();
        return response;
      }
      // dispatch(activeSnack({ type: 'success', message: 'Successfully Authenticated ' }));

      return dispatch(activeSnack({ type: 'error', message: 'something went wrong' }));
    } catch (error) {
      dispatch(activeSnack({ type: 'error', message: error?.response?.data?.message }));
      throw error?.response?.data?.message;
    }
  }
);
export const EnquiryApi = createAsyncThunk('/enquiry/new', async ({ state, dispatch, reset }) => {
  try {
    const response = await post('/enquiry/new', state);

    if (response) {
      dispatch(activeSnack({ type: 'success', message: 'Successfully Submitted' }));
      if (reset) {
        return reset();
      }
      return response;
    }

    return dispatch(activeSnack({ type: 'error', message: 'something went wrong' }));
  } catch (error) {
    dispatch(activeSnack({ type: 'error', message: error?.response?.data?.message }));
    throw error?.response?.data?.message;
  }
});

export const ContactApi = createAsyncThunk(
  '/contact/create',
  async ({ state, dispatch, reset }) => {
    try {
      const response = await contactPost(
        'https://mail-sender.vingb.com/send/edbffb4e-62b1-4a3c-94af-052f53602300',
        state
      );

      if (response) {
        dispatch(activeSnack({ type: 'success', message: 'Successfully Submitted' }));
        if (reset) {
          return reset();
        }
        return response;
      }

      return dispatch(activeSnack({ type: 'error', message: 'something went wrong' }));
    } catch (error) {
      console.log(error);
      dispatch(activeSnack({ type: 'error', message: error?.response?.data?.message }));
      throw error?.response?.data?.message;
    }
  }
);

export const authSlice = createSlice({
  name: 'auth',
  initialState: {
    passwordLoading: false,
    forgottLoading: false,
    loading: false,
    loginLoading: false,
    error: {},
    CheckUserNames: {},
    user: {
      email: '',
      username: '',
      isActive: false,
    },
    User: {},
    payment: {},
    memberProfileDetails: {},
    advertiserProfileDetails: {},
    loginData: {},
    ResentOTP: {},
    verifyOTP: {},
    admin: {},
    enquiry: {},
  },
  reducers: {},
  extraReducers: {
    // login
    [memberLoginApi.pending]: (state) => {
      state.loginLoading = true;
    },
    [memberLoginApi.fulfilled]: (state, action) => {
      state.loginLoading = false;
      state.user = action.payload;
      state.error = {};
    },
    [memberLoginApi.rejected]: (state, action) => {
      state.loginLoading = false;
      state.error = action.error;
    },
    /// admin login
    [LoginApi.pending]: (state) => {
      state.loginLoading = true;
    },
    [LoginApi.fulfilled]: (state, action) => {
      state.loginLoading = false;
      state.loginData = action.payload;
      state.error = {};
    },
    [LoginApi.rejected]: (state, action) => {
      state.loginLoading = false;
      state.error = action.error;
    },
    // update profile

    // register
    [memberRegisterApi.pending]: (state) => {
      state.loginLoading = true;
    },
    [memberRegisterApi.fulfilled]: (state, action) => {
      state.loginLoading = false;
      state.User = action.payload;
      state.error = {};
    },
    [memberRegisterApi.rejected]: (state, action) => {
      state.loginLoading = false;
      state.error = action.error;
    },

    // profile
    [getMemberProfile.pending]: (state) => {
      state.loading = true;
    },
    [getMemberProfile.fulfilled]: (state, action) => {
      state.loading = false;
      state.user = action.payload;
      state.error = {};
    },
    [getMemberProfile.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.error;
    },

    // advertiser profile

    [getAdvertiserProfile.pending]: (state) => {
      state.loading = true;
    },
    [getAdvertiserProfile.fulfilled]: (state, action) => {
      state.loading = false;
      state.advertiserProfileDetails = action.payload;
      state.error = {};
    },
    [getAdvertiserProfile.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.error;
    },

    // update profile
    [updateMemberProfile.pending]: (state) => {
      state.loading = true;
    },
    [updateMemberProfile.fulfilled]: (state, action) => {
      state.loading = false;
      state.user = action.payload;
      state.error = {};
    },
    [updateMemberProfile.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.error;
    },

    // logout
    [logoutApi.fulfilled]: (state) => {
      state.user = {};
      state.error = {};
    },
    [logoutApi.rejected]: (state, action) => {
      state.error = action.error;
    },

    [forgotPassword.pending]: (state) => {
      state.forgottLoading = true;
    },
    [forgotPassword.fulfilled]: (state) => {
      state.forgottLoading = false;
      state.error = {};
    },
    [forgotPassword.rejected]: (state, action) => {
      state.forgottLoading = false;
      state.error = action.error;
    },

    [updatePassword.pending]: (state) => {
      state.loading = true;
    },
    [updatePassword.fulfilled]: (state) => {
      state.loading = false;
      state.error = {};
    },
    [updatePassword.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.error;
    },
    //  check username
    [CheckUserName.pending]: (state) => {
      state.loading = true;
    },
    [CheckUserName.fulfilled]: (state, action) => {
      console.log('username', action.payload);
      state.loading = false;
      state.CheckUserNames = action.payload;
      state.error = {};
    },
    [CheckUserName.rejected]: (state, action) => {
      console.log('errr', action.error);
      state.loading = false;
      state.error = action.error;
    },
    // resent
    [ResentOtpApi.pending]: (state) => {
      state.loading = true;
    },
    [ResentOtpApi.fulfilled]: (state, action) => {
      console.log('username', action.payload);
      state.loading = false;
      state.ResentOTP = action.payload;
      state.error = {};
    },
    [ResentOtpApi.rejected]: (state, action) => {
      console.log('errr', action.error);
      state.loading = false;
      state.error = action.error;
    },

    [verifyOtpApi.pending]: (state) => {
      state.loading = true;
    },
    [verifyOtpApi.fulfilled]: (state, action) => {
      console.log('username', action.payload);
      state.loading = false;
      state.verifyOTP = action.payload;
      state.error = {};
    },
    [verifyOtpApi.rejected]: (state, action) => {
      console.log('errr', action.error);
      state.loading = false;
      state.error = action.error;
    },
    // enquiry
    [EnquiryApi.pending]: (state) => {
      state.loginLoading = true;
    },
    [EnquiryApi.fulfilled]: (state, action) => {
      state.loginLoading = false;
      state.enquiry = action.payload;
      state.error = {};
    },
    [EnquiryApi.rejected]: (state, action) => {
      state.loginLoading = false;
      state.error = action.error;
    },
  },
});
// export const {} = authSlice.actions;

export default authSlice.reducer;
